module.exports = __webpack_public_path__ + "img/SKMJ_fire2.cedaa3dc.jpg";